import { FC } from "react"
import { useTranslation } from "react-i18next"
import { useParams, useSearchParams } from "react-router-dom"

import { useAppDispatch } from "../../core/app/hooks"
import { unlockCaseApi } from "../../core/app/slices/clinical/clinicalThunkApi"
import { useMyNavigation } from "../../hooks/useMyNavigation"
import { UButton, UModalPopup, UText } from "../../ui-component/components"
import { Box } from "../../ui-component/mui.components"
import { caseManagement } from "@/gluelayer"
import { resetCase } from "../../core/app/slices/clinical/clinicalSlice"
import { safeCloseWindow } from "@/core/app/CloseTabContext"

const ExitOrderAlertPopup: FC<{
  showAlert: boolean
  closeAlert: () => void
  buttonTxt: string
  confirmAction?: () => void
}> = ({ showAlert, closeAlert, buttonTxt ,confirmAction}) => {
  const { t } = useTranslation("common")
  const navigate = useMyNavigation()
  const { patientId, caseId } = useParams()
  const dispatch = useAppDispatch()
  const [searchParams] = useSearchParams()
  const from = searchParams.get("from")

  const handleNavigate = async () => {
    caseManagement.closeCase();
    await dispatch(resetCase());
    dispatch(unlockCaseApi({ patientId, caseId })).then((res) => {
      if (buttonTxt === "Back") {
        navigate(`/clinical/patient/${patientId}/case/${caseId}/treat${from && `?from=${from}`}`)
      } else {
        // (from === "patientList" && window.opener) ? window.close() : navigate("/patients")
        safeCloseWindow()
      }
    })
  }

  return (
    <UModalPopup
      isAlert={showAlert}
      title={
        <UText
          variant={"h6"}
          sxProp={{
            width: "396px",
          }}
        >
          {t("exitBundlePopup.title")}
        </UText>
      }
      sxModalProps={{
        ".MuiDialog-paper": {
          maxWidth: 444,
        },
        "#titleCntr": {
          padding: "16px 24px",
        },
        "#contentCntr": {
          padding: "20px 24px",
        },
        "#btnListCntr": {
          padding: 1,
          gap: 1,
        },
      }}
      content={
        <Box component={"div"}>
          <UText variant={"body1"} sxProp={{ display: "block" }}>
            {t("exitBundlePopup.description")}
          </UText>
        </Box>
      }
      btnList={[
        <UButton
          key={t("exitBundlePopup.continueBundleBtn")}
          variant="shade"
          btnText={t("exitBundlePopup.continueBundleBtn")}
          onClickHandler={closeAlert}
          sxProp={{
            height: 36,
          }}
        ></UButton>,
        <UButton
          key={t("exitBundlePopup.leaveBtn")}
          variant="contained"
          btnText={t("exitBundlePopup.leaveBtn")}
          sxProp={{
            width: 128,
            height: 36,
          }}
          onClickHandler={confirmAction?confirmAction:handleNavigate}
        ></UButton>,
      ]}
    ></UModalPopup>
  )
}
export default ExitOrderAlertPopup
